import {
  Box,
  Button,
  ButtonProps,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AuthCommon from "../../Components/Auth";
import variables from "../../../assets/styles/variables.module.scss";
import { Visibility, VisibilityOff, CheckCircleOutline as CheckCircleOutlineIcon } from "@mui/icons-material";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { PasswordStrengthCheck, ValidateEmailIsOrg, ValidateIsEmail } from "../../../Shared-ui/utils/Auth/AuthHelpers";
import Strength from "../../../Shared-ui/Types/Auth";
import { useDispatch } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { FG_RESEND_SEND_OTP, FG_RESET_PASSWORD, FG_SEND_OTP, FG_VERIFY_OTP } from "../../../Services/Endpoint";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const VerificationBox = styled(Box)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#80bdff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
    },
  },
  "& input": {
    textAlign: "center",
    letterSpacing: "0.5em",
    fontSize: "1.5rem",
  },
});

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryColor,
  "&:hover": {
    backgroundColor: variables.secondaryColor,
  },
}));

interface MyComponentProps {

}


const ForgotPassword: React.FC<MyComponentProps> = (props) => {

  const navigate = useNavigate()

  const dispatch = useDispatch();
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [isOtpVerify, setIsOtpVerify] = useState<boolean>(false);
  const [isOtpVerifyMsg, setIsOtpVerifyMsg] = useState<boolean>(false);
  const [otpValues, setOtpValues] = useState<string[]>(Array(6).fill(""));
  const [countdown, setCountdown] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [verificationCode, setVerificationCode] = useState<string>("");
  const [otpSentEmail, setOtpSentEmail] = useState<string>("");

  const [forgotErr, setForgotErr] = useState({
    email: { error: "", value: false },
  });


  const [showPassword, setShowPassword] = useState<{ [key: string]: boolean }>({
    confirmPassword: false,
    password: false,
  }); // New state for toggle

  const [strengthNew, setStrengthNew] = useState<Strength>({
    label: "Password strength ",
    color: "",
    strength: "",
  });

  const [strengthConf, setStrengthConf] = useState<Strength>({
    label: "Password strength ",
    color: "",
    strength: "",
  });

  const [resetForm, setResetForm] = useState({
    email: "",
    confirm_password: "",
    new_password: "",
  });

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isOtpSent && countdown > 0) {
      setCanResend(false);
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }

    else if (countdown === 0 && isOtpSent) {
      setCanResend(true);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isOtpSent, countdown]);


  useEffect(() => {

  }, [])





  const handleTogglePassword = (fieldName: string) => {
    let value = showPassword[fieldName];
    setShowPassword((prev) => ({ ...prev, [fieldName]: !value })); // Toggle show/hide
  };


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setResetForm((preVal) => ({ ...preVal, [name]: value }));
    if (name === "new_password") {
      setStrengthNew(PasswordStrengthCheck(value));
      if (!value) setStrengthNew({ label: "Password strength ", color: "", strength: "" })
    }
    // if (name === "confirmPassword") {
    //   setStrengthConf(PasswordStrengthCheck(value));
    // }
  };
  const validatePassword = () => {

    if (
      Number(strengthNew.strength) != 80 &&
      Number(strengthNew.strength) != 100
    ) {
      return false;
    }
    // if (
    //   Number(strengthConf.strength) != 80 &&
    //   Number(strengthConf.strength) != 100
    // ) {
    //   return false;
    // }
    if (resetForm.new_password !== resetForm.confirm_password) {
      dispatch(ShowError("Password not match"));
      return false;
    }
    return true
  };

  const validateEmail = () => {
    if (!ValidateIsEmail(resetForm.email)) {
      setForgotErr((preVal: any) => ({ ...preVal, email: { error: "Please enter valid email", value: true } }))
      return false
    } else if (!ValidateEmailIsOrg(resetForm.email) || !resetForm.email.trim()) {
      setForgotErr((preVal: any) => ({ ...preVal, email: { error: "Personal email is are not allowed", value: true } }))
      return false
    } else {
      setForgotErr((preVal: any) => ({ ...preVal, email: { error: "", value: false } }))
    }
    return true;
  }


  const formatCountdown = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };


  const handleOtpChange = (index: number, value: string) => {
    if (!/^[0-9]*$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    setVerificationCode(newOtpValues.join(""));

    // Auto focus next input
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>
  ) => {
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      const prevInput = document.getElementById(
        `otp-${index - 1}`
      ) as HTMLInputElement;
      prevInput?.focus();
    }
  };


  const handleSubmit = async () => {
    try {
      dispatch(StartLoading());
      const data = await axios.post(`${FG_RESET_PASSWORD}`, resetForm).then((res) => res?.data);
      dispatch(ShowSuccess(data?.message));
      navigate("/login");
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  }

  const handleSendOtp = async () => {
    try {
      if (!validateEmail()) return;
      dispatch(StartLoading());
      setCountdown(300); 
        setCanResend(false); 
        // setIsOtpSent(true);
      const data = await axios.post(`${FG_SEND_OTP}`, { email: resetForm.email }).then((res) => res?.data);
      setIsOtpSent(true);
      setOtpSentEmail(resetForm.email);
      dispatch(ShowSuccess(data?.message)); 
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
       setCountdown(0); 
        setCanResend(true); 
        setIsOtpSent(false);
    } finally {
      dispatch(StopLoading());
    }
  }

  const handleVerifyOtp = async () => {
    try {
      dispatch(StartLoading());
      const response = await axios.post(`${FG_VERIFY_OTP}`, { email: resetForm.email, otp_code: verificationCode }).then((res) => res?.data);
      if (!response.verified) {
        dispatch(ShowError(response?.message));
      } else {
        setIsOtpVerify(response?.verified || false)
        setIsOtpVerifyMsg(response?.message || "")
      }
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  }

  const handleResendOtp = async () => {
    try {
      if (!validateEmail()) return;
      dispatch(StartLoading());
      setCountdown(300); 
      setCanResend(false);
      const data = await axios.post(`${FG_RESEND_SEND_OTP}`, { email: resetForm.email }).then((res) => res?.data);
      setIsOtpSent(true);
      setOtpSentEmail(resetForm.email);
      dispatch(ShowSuccess(data?.message));
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
       setCountdown(0);
       setCanResend(true);
    } finally {
      dispatch(StopLoading());
    }
  }

  return (
    <>
      {isOtpVerify ? (
        <Box
          sx={{
            display: "flex",
            minHeight: "calc(100vh - 78px)",
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <AuthCommon />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              px: { xl: 30, lg: 20, md: 8, sm: 8, xs: 5 },
              py: { sm: 6, xs: 3 },
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              <Typography variant="h4" fontWeight="500">
                Welcome Back
              </Typography>
              <Typography>
                Enter a strong new password, using a mix of letters, numbers, and symbols.
              </Typography>

              <FormControl fullWidth variant="outlined">
                <InputLabel
                  htmlFor="newPassword"
                  shrink
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  New password
                </InputLabel>
                <OutlinedInput
                  id="new_password"
                  name="new_password"
                  type={showPassword.password ? "text" : "password"}
                  onChange={handleChange}
                  placeholder="New Password"
                  sx={{ background: "white" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleTogglePassword("password")}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword.password ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="New Password"
                />
              </FormControl>

              <FormControl fullWidth variant="outlined">
                <InputLabel
                  htmlFor="confirm Password"
                  shrink
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  confirm password
                </InputLabel>
                <OutlinedInput
                  id="confirm_password"
                  name="confirm_password"
                  type={showPassword.confirmPassword ? "text" : "password"}
                  onChange={handleChange}
                  placeholder="Confirm Password"
                  sx={{ background: "white" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleTogglePassword("confirmPassword")}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword.confirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="New Password"
                />
              </FormControl>
              <Box>
                <Box
                  sx={{
                    height: "4px",
                    width: "100%",
                    backgroundColor: "lightgray",
                    borderRadius: "2px",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      height: "100%",
                      width: `${strengthNew.strength}%`,
                      backgroundColor: strengthNew.color,
                    }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  color={strengthNew.color}
                  sx={{ mt: 1, textAlign: "right", display: "block" }}
                >
                  {strengthNew.label}
                </Typography>
              </Box>

              <ColorButton
                variant="contained"
                disableElevation
                size="large"
                sx={{
                  textTransform: "capitalize",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                }}
                //onClick={() => handleSubmit()}
                onClick={handleSubmit} // Trigger the alert
              >
                Submit
              </ColorButton>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            minHeight: "calc(100vh - 78px)",
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <AuthCommon />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              px: { xl: 30, lg: 20, md: 8, sm: 8, xs: 5 },
              py: { sm: 6, xs: 3 },
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              <Typography variant="h4" fontWeight="500">
                Reset Password
              </Typography>
              <Typography>
                Enter your email to receive instructions on how to reset your
                password.
              </Typography>
              {/* {isOtpSent && ( 
                <Alert variant="filled" severity="success">
                  If an account with that email exists, a password reset OTP
                  will be sent to your email.
                </Alert>
              )} */}
              <FormControl
                fullWidth
                variant="outlined"
                error={forgotErr.email.value}
              >
                <InputLabel
                  htmlFor="email"
                  shrink
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  Business Email
                </InputLabel>
                <TextField
                  id="email"
                  name="email"
                  placeholder="Enter your business email"
                  value={resetForm.email}
                  sx={{ background: "white" }}
                  onChange={(e) => setResetForm((preVal) => ({ ...preVal, email: e.target.value }))}
                  error={forgotErr.email.value}
                  helperText={forgotErr.email.error}
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              </FormControl>

              <Button
                variant="contained"
                size="large"
                onClick={handleSendOtp}
                disableElevation
                disabled={!resetForm.email || (isOtpSent && countdown > 0) }
                sx={{
                  backgroundColor: variables.primaryColor,
                  color: variables.whiteColor,
                  textTransform: "none",
                  minWidth: "120px",
                  mt: 1,
                  "&:hover": {
                    backgroundColor: variables.secondaryColor,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: variables.softGray,
                    color: "text.secondary",
                  },
                }}
              >
                Send OTP
              </Button>
              {isOtpSent && !isOtpVerify && (
                <Box >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      background: "#E0F6F0",
                      borderLeft: "4px solid #23B684",
                      borderRadius: "10px",
                      px: 2,
                      py: 1.5,
                      mb: 2,
                      color: "#23B684",
                      position: "relative",
                      minHeight: 56,
                    }}
                  >
                    <CheckCircleOutlineIcon sx={{ fontSize: 20, mr: 1 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#23B684",
                          fontWeight: 500,
                          lineHeight: 1.2,
                        }}
                      >
                        Verification code sent to
                        <br />
                        {otpSentEmail}
                      </Typography>
                    </Box>
                    {countdown > 0 && (
                      <Typography
                        component="span"
                        sx={{
                          color: "#23B684",
                          fontWeight: 500,
                          ml: 2,
                          minWidth: 48,
                          textAlign: "right",
                        }}
                      >
                        ({formatCountdown(countdown)})
                      </Typography>
                    )}
                  </Box>

                  <VerificationBox>
                    <FormControl fullWidth variant="outlined">
                      {/* <InputLabel shrink sx={{ background: "#fff", px: 0.5 }}>
                                Enter 6-digit code
                              </InputLabel> */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          mt: 1,
                          justifyContent: "space-between",
                        }}
                      >
                        {Array(6)
                          .fill(0)
                          .map((_, index) => (
                            <TextField
                              key={index}
                              id={`otp-${index}`}
                              value={otpValues[index]}
                              onChange={(e) =>
                                handleOtpChange(index, e.target.value)
                              }
                              onKeyDown={(e) => handleKeyDown(index, e)}
                              inputProps={{
                                maxLength: 1,
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                                style: {
                                  textAlign: "center",
                                  fontSize: "1.5rem",
                                  padding: "8px",
                                  width: "60px",
                                  letterSpacing: "normal",
                                },
                              }}
                              sx={{
                                background: "white",
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: "#e0e0e0",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#80bdff",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#1976d2",
                                  },
                                },
                              }}
                            />
                          ))}
                      </Box>
                    </FormControl>
                  </VerificationBox>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 2,
                      gap: 2,
                    }}
                  >
                    <Button
                      fullWidth
                      size="large"
                      disableElevation
                      variant="contained"
                      onClick={() => handleVerifyOtp()}
                      disabled={verificationCode.length !== 6 || !resetForm.email}
                      sx={{
                        textTransform: "capitalize",
                        backgroundColor: variables.primaryColor,
                        color: variables.whiteColor,
                        "&:hover": {
                          backgroundColor: variables.secondaryColor,
                        },
                      }}
                    >
                      Verify
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      size="large"
                      onClick={() => handleResendOtp()}
                      disabled={!canResend}
                      sx={{
                        color: variables.primaryButton,
                        "&:hover": {
                          backgroundColor: "transparent",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      Resend
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>

        </Box>
      )}
    </>
  );
};

export default ForgotPassword;

